// extracted by mini-css-extract-plugin
export default {"key":"line-items-rfq-summary_key__PAYuH"};